module.exports = __webpack_public_path__ + "static/micron21-08070acf2550adaee0c4b3ad3bf4629b.svg";